import { useState } from "react";
import Navbar from "../Navbar";
import ActiveDriverLayout from "./ActiveDriverLayout";

const ActiveDriversPage = () => {
  const [date, setDate] = useState(null);

  return (
    <div className="h-screen w-screen mt-16">
      <Navbar />

      <div className="">
        <ActiveDriverLayout value={10} date={date} setDate={setDate} />
      </div>
    </div>
  );
};

export default ActiveDriversPage;
